import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Map } from 'immutable';

import { isEnterOrSpace } from '@Utils/KeyboardUtil';
import BreadcrumbTooltip from '@Containers/Breadcrumbs/BreadcrumbTooltip/BreadcrumbTooltip';

export const QUICK_SEARCH_ACTIONS = {
  PREVIEW: 'preview',
  EDIT: 'edit',
};

function BackToQueryBreadcrumbs({ breadcrumb, isBackToQueryVisible, isBackToQueryBuilder, backToQueryHandler, breadcrumbsOrder }) {
  const [showSearchTooltip, setShowSearchTooltip] = useState(false);
  const [showPreviewTooltip, setShowPreviewTooltip] = useState(false);

  const getEditTooltipHeader = () => {
    return `Edit search in ${isBackToQueryBuilder ? 'query builder' : 'quick search'}`;
  };

  const backToQuery = (action) => {
    backToQueryHandler(breadcrumb.toJS(), action);
  };

  const getBackToBreadcrumb = (setShowHandler, showFlag, action, label, icon, e2eName, tooltipHeader) => {
    const tooltipId = `back-to-${label.replace(/\s+/g, '-').toLowerCase()}`;
    return (
      <li
        className={classnames('new-breadcrumbs__item')}
        onMouseEnter={() => setShowHandler(true)}
        onMouseLeave={() => setShowHandler(false)}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          role="button"
          className={`e2e-breadcrumb e2e-breadcrumb-${e2eName} new-breadcrumbs__link`}
          onClick={action}
          tabIndex="0"
          href
          onKeyPress={(e) => (isEnterOrSpace(e) ? action() : null)}
          aria-label={`Breadcrumb link to ${tooltipHeader}`}
          data-tip
          data-for={tooltipId}>
          <span className="new-breadcrumbs__link-content new-breadcrumbs__clip-content">
            <svg className="svg-icon svg-icon--medium new-breadcrumbs__icon">
              <use xlinkHref={icon} />
            </svg>
            {label}
          </span>
        </a>
        <BreadcrumbTooltip id={tooltipId} breadcrumb={breadcrumb} header={tooltipHeader} isAlertVisible={false} />
      </li>
    );
  };

  const getBackToQueryBreadcrumb = () => {
    return getBackToBreadcrumb(
      setShowSearchTooltip,
      showSearchTooltip,
      () => backToQuery(QUICK_SEARCH_ACTIONS.EDIT),
      'Search',
      '#icon-search',
      isBackToQueryBuilder ? 'query' : 'qs',
      getEditTooltipHeader()
    );
  };

  const getBackToPreviewBreadcrumb = () => {
    return getBackToBreadcrumb(
      setShowPreviewTooltip,
      showPreviewTooltip,
      () => backToQuery(QUICK_SEARCH_ACTIONS.PREVIEW),
      'Preview',
      '#icon-breadcrumbs-preview',
      'preview',
      'Preview results'
    );
  };

  return isBackToQueryVisible ? (
    <>
      {!isBackToQueryBuilder && breadcrumbsOrder === 'desktop' && getBackToPreviewBreadcrumb()}
      {getBackToQueryBreadcrumb()}
      {!isBackToQueryBuilder && breadcrumbsOrder === 'tablet' && getBackToPreviewBreadcrumb()}
    </>
  ) : null;
}

BackToQueryBreadcrumbs.propTypes = {
  breadcrumb: PropTypes.instanceOf(Map).isRequired,
  isBackToQueryVisible: PropTypes.bool,
  isBackToQueryBuilder: PropTypes.bool,
  backToQueryHandler: PropTypes.func.isRequired,
  breadcrumbsOrder: PropTypes.string,
};

export default BackToQueryBreadcrumbs;
